import { useState } from 'react';
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import LinkClicksChartHeader from './LinkClicksChartHeader';
import { DAY, MONTH } from '../../../../constants';
import { useTranslation } from 'react-i18next';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const PERIOD_OPTIONS = [
  { value: MONTH, labelKey: 'linkClicks.month' },
  { value: DAY, labelKey: 'linkClicks.day' }
];

const LABEL_FORMATS = {
  [MONTH]: { month: 'short', year: 'numeric' },
  [DAY]: { month: 'short', day: '2-digit' }
};

const ClicksOverTime = ({ trend }) => {
  const [period, setPeriod] = useState(MONTH);
  const { t, i18n } = useTranslation();
  const points = trend[period];
  const formatLabel = new Intl.DateTimeFormat(
    i18n.language,
    LABEL_FORMATS[period]
  ).format;

  const data = {
    labels: points.map(({ date }) => formatLabel(new Date(date))),
    datasets: [
      {
        label: t('linkClicks.totalClicks'),
        data: points.map(({ total }) => total),
        borderColor: '#3a83f6',
        backgroundColor: '#3a83f6',
        borderWidth: 2,
        pointRadius: 0,
        pointHoverRadius: 4,
        tension: 0
      },
      {
        label: t('linkClicks.uniqueClicks'),
        data: points.map(({ unique }) => unique),
        borderColor: '#f8a40f',
        backgroundColor: '#f8a40f',
        borderWidth: 2,
        borderDash: [5, 4],
        pointRadius: 0,
        pointHoverRadius: 4,
        tension: 0
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index', intersect: false },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          color: '#8b929a',
          usePointStyle: true,
          pointStyle: 'rect',
          boxWidth: 8,
          boxHeight: 8,
          padding: 24
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: { color: '#3e4957', font: { size: 11 } }
      },
      y: {
        beginAtZero: true,
        grid: { color: '#ebebeb' },
        border: { display: false },
        ticks: { color: '#3e4957', font: { size: 11 } }
      }
    }
  };

  return (
    <section className="bg-white rounded-4 p-3 p-md-4">
      <LinkClicksChartHeader
        title={t('linkClicks.clicksOverTime')}
        description={t('linkClicks.clicksOverTimeDescription')}
        options={PERIOD_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) }))}
        activeOption={period}
        onOptionChange={setPeriod}
      />
      <div className="link-clicks-line-chart">
        <Line data={data} options={options} aria-label={t('linkClicks.clicksOverTimeDescription')} />
      </div>
    </section>
  );
};

export default ClicksOverTime;
